<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-list-legacy [listItems]="itemsListValid" ltype="multi" [optionfunc]="toggleChosen.bind(this)"></tt-list-legacy>

        <tt-card>
            <tt-button-save ttText="sopvalid_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <div class="col-xs-12 col-md-4 p-5">
                <tt-page-heading [ttModel]="'h_info'" ttTranslate></tt-page-heading>

                <tt-card>
                    <ng-container *ngTemplateOutlet="info"></ng-container>
                </tt-card>
            </div>

            <div class="col-xs-12 col-md-4 p-5">
                <tt-page-heading [ttModel]="'h_valid'" ttTranslate></tt-page-heading>
                <tt-list-legacy [listItems]="itemsListValid" ltype="multi" [optionfunc]="toggleChosen.bind(this)"></tt-list-legacy>
            </div>
        </div>

        <tt-card class="col-xs-12 col-md-8 p-5">
            <tt-button-save ttText="sopvalid_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="sop_keyno" [ttModel]="menu.sop_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="sop_name" [ttModel]="menu.sop_name" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0">
    <div class="col-xs-12 sp-0">
        <div class="col-xs-12 col-md-4 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_info" tt-translate="true"></tt-page-heading>

            <tt-card>
                <tt-input class="col-xs-12 sp-0" tt-label="sop_keyno" tt-model="vm.model.menu.sop_keyno" tt-change="vm.model.menu.sop_keyno = $value" tt-readonly="true"></tt-input>
                <tt-input class="col-xs-12 sp-0" tt-label="sop_name" tt-model="vm.model.menu.sop_name" tt-change="vm.model.menu.sop_name = $value" tt-readonly="true"></tt-input>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-4 p-5">
            <tt-page-heading class="col-xs-12 sp-0" tt-model="h_valid" tt-translate="true"></tt-page-heading>
            <tt-list class="col-xs-12 sp-0" list-items="vm.model.itemsListValids" badge="" ltype="custom" design-var="s12t0" optionfunc="vm.toggleChosen(item)"></tt-list>
        </div>
    </div>

    <tt-card class="col-xs-12 col-md-8 p-5">
        <tt-button-save class="col-xs-12 sp-0" tt-text="sopvalid_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
